/**
 * Stripe client secrets are shaped `pi_xxx_secret_yyy`.
 * Prefer an explicit paymentIntentId from the API when available.
 */
export const paymentIntentIdFromClientSecret = (
  clientSecret: string | null | undefined,
): string | null => {
  if (!clientSecret) {
    return null;
  }
  const secretMarker = '_secret';
  const markerIndex = clientSecret.indexOf(secretMarker);
  if (markerIndex <= 0) {
    return null;
  }
  const paymentIntentId = clientSecret.slice(0, markerIndex);
  return paymentIntentId.startsWith('pi_') ? paymentIntentId : null;
};
